// State machine for network status

import networkStatus from '../networkStatus';

export default {
  strict: true,
  namespaced: true,
  state: {
    offline: false,
  },
  mutations: {
    setOffline(state, offline) {
      state.offline = offline;
      networkStatus.setOffline(offline);
    },
  },
};
